export interface UserStamp {
  userId: string;
  userName: string;
  userEmail: string;
}

/** The acting user for optimistic stamps outside React, from the entry AuthProvider persists on login. */
export function readCurrentUserStamp(): UserStamp | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem("auth_user");
    if (!raw) return null;
    const user = JSON.parse(raw) as { id?: string; email?: string; name?: string };
    if (!user?.email) return null;
    return { userId: user.id || "", userName: user.name || user.email, userEmail: user.email };
  } catch {
    return null;
  }
}
